import axios from 'axios';
import { apiClient } from '../client';
import { propertyEndpoints } from '../endpoints/property.endpoints';
import type { ApiResponse } from '../types/envelope.types';
import type { AccessibleProperty } from '../types/property.types';

function throwFromEnvelope(err: unknown, fallback: string): never {
  if (axios.isAxiosError(err) && err.response?.data) {
    const body = err.response.data as ApiResponse<unknown>;
    throw new Error(body.message || err.message || fallback);
  }
  throw err instanceof Error ? err : new Error(fallback);
}

export const propertyService = {
  async getAccessible(): Promise<AccessibleProperty[]> {
    try {
      const res = await apiClient.get<ApiResponse<AccessibleProperty[]>>(
        propertyEndpoints.accessible(),
      );
      const body = res.data;
      if (!body.success || !body.data) {
        throw new Error(body.message || 'Failed to load properties');
      }
      return body.data;
    } catch (err) {
      throwFromEnvelope(err, 'Failed to load properties');
    }
  },
};
